import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Neutrals, Primary } from "../../../core-components/theme/color-palette/colors";
import useFetchStructure from "../hooks/useFetchStructure";
import { useParams } from "react-router-dom";
import SpriteIcon from "../../../core-components/assets/Icon";
import { fMpathConstants } from "../fileManagerConstants";
import { SelectedFilesInterface } from "../types";

const SelectedFiles = ({fileObj, handleDelete, handleSelectChange, index, handleSelectPreview}: SelectedFilesInterface) => {
  const {assetId = ''} = useParams() as {assetId: string};
  const { data: categoryList } = useFetchStructure({queryKey: ['fm-category'], payload: {assetId: assetId}, path: fMpathConstants.FMListFoldersForPlant, enabled: true});
  const { data: subCategoryList } = useFetchStructure({queryKey: ['fm-sub-category', fileObj?.category], payload: {assetId: assetId, subPath: `${fileObj?.category}/`}, path: fMpathConstants.FMListFoldersForPlant, enabled: !!fileObj?.category});

  return (
    <Stack rowGap={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{marginTop: 0}}>
        <Typography variant="body1" sx={{fontSize: '14px', fontWeight: 700, color: Neutrals[500]}}>
          {fileObj?.file?.name}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={2}>
          <SpriteIcon id={'file_preview'} width="20" height="20" style={{cursor: 'pointer'}} onClick={() => handleSelectPreview(fileObj?.file)} />
          <DeleteOutlinedIcon onClick={() => handleDelete(index)} sx={{color: Primary[900], cursor: 'pointer'}}/>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={4}>
        <FormControl sx={{ minWidth: 120, flex: 1 }}>
          <InputLabel id={`category-select-dropdown${index}`}>Category</InputLabel>
          <Select
            name="category"
            id={`category-select-dropdown${index}`}
            value={fileObj?.category || ''}
            label="Category"
            onChange={(e) => handleSelectChange(e, 'category', index)}
          >
            {
              categoryList?.map((value: string) => {
                return <MenuItem key={value} value={value}>{value}</MenuItem>
              })
            }
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 120, flex: 1 }}>
          <InputLabel id={`subcategory-select-dropdown${index}`}>Sub Category</InputLabel>
          <Select
            id={`subcategory-select-dropdown${index}`}
            value={fileObj?.subCategory || ''}
            label="Sub Category"
            disabled={!fileObj?.category}
            onChange={(e) => handleSelectChange(e, 'subCategory', index)}
          >
            {
              subCategoryList?.map((value: string) => {
                return <MenuItem key={value} value={value}>{value}</MenuItem>
              })
            }
          </Select>
        </FormControl>
      </Stack>
    </Stack>
  )
}

export default SelectedFiles;